import * as React from 'react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { S24IconProps } from '@is24/cosma-ui-icons/build/helper'
import { Styles } from '../../../../@types/types'
import { ScreenName } from '../../../../services/domain/wizardScreens'
import { isWebView } from '../../../../utils/navigation'
import { MandatoryHintWrapper } from '../../display/mandatoryHint/MandatoryHintWrapper'
import { Section } from 'is24-corecss'
import { useAppSelector } from '../../../../app/hooks'
import { InitState } from '../../../../redux/reducers/root/initialState'

export interface ScreenLayoutProps {
  id: string
  deskTooltip?: ReactElement
  mobileTooltip?: ReactElement
  headline: string
  subLine?: string
  screenName: ScreenName
  headerIcon?: ReactElement<S24IconProps>
  className?: string
  showMandatoryHint?: boolean
  children?: React.ReactNode
}

const styles: Styles = {
  tooltip: {
    paddingLeft: 98,
  },
}

export const ScreenLayout: React.FC<ScreenLayoutProps> = ({
  id,
  deskTooltip,
  mobileTooltip,
  headline,
  subLine,
  screenName,
  headerIcon,
  children,
  className,
  showMandatoryHint = true,
}) => {
  const { t } = useTranslation()
  const isMobile = isWebView()
  const isWaitingListFlow = useAppSelector(
    (state: InitState) => state.flowFeature.flowInformation.options?.isWaitingListFlow
  )

  return (
    <Section subline={subLine} title={t(headline)} titleTag={isMobile ? 'h4' : 'h3'} topLeftSlot={headerIcon}>
      <div className='grid'>
        <div className={`grid-item ${isMobile ? '' : 'desk-seven-twelfths'}`}>
          <div className={className ? className : ''}>
            {children}
            {!(isWaitingListFlow || isMobile) && (
              <MandatoryHintWrapper
                showMandatoryHint={showMandatoryHint}
                screenNames={[screenName]}
                className={className}
              />
            )}
          </div>
        </div>
        <div
          id={id}
          className={`grid-item palm-hide lap-hide ${isMobile ? 'desk-hide' : 'desk-five-twelfths'}`}
          style={styles.tooltip}
          data-testid={`${screenName}_tooltip`}
        >
          {deskTooltip && <span>{deskTooltip}</span>}
        </div>
      </div>
      {mobileTooltip && <span>{mobileTooltip}</span>}
    </Section>
  )
}
